// extracted by mini-css-extract-plugin
export var EcommerceB2B = "index-module--EcommerceB2B--yTZ6f";
export var Footer = "index-module--Footer--eJyAh";
export var TabBgColor = "index-module--TabBgColor---Xaqz";
export var TabShadow = "index-module--TabShadow--18duK";